import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { NavLink } from "react-router-dom";
import "./navbar.css";


export default function Navbar() {
  return (
    <nav className="bg-white py-2 border-top border-bottom sticky-top">
      <div className="container">
        <ul className="nav justify-content-center flex-wrap gap-2">
          {[
            { label: "Home", path: "/orrbiitelegance" },
            { label: "About", path: "/orrbiitabout" },
            { label: "Categories", path: "/category", end: true },
            { label: "Packages", path: "/boutiqueproducts3" },
            { label: "Support", path: "/support" },
          ].map(({ label, path, end }) => (
            <li key={label} className="nav-item">
              <NavLink
                to={path}
                end={end}
                className={({ isActive }) =>
                  `nav-link text-dark fw-medium ${isActive ? "active" : ""}`
                }
                style={{ fontSize: "1rem" }}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
